import InfoIcon from "@mui/icons-material/Info";
import MenuIcon from "@mui/icons-material/Menu";
import { Box, Divider, Drawer, Link, IconButton } from "@mui/material";
import { pink } from "@mui/material/colors";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import ReactGA from "react-ga4";
import { useLocation } from "react-router";

import { ENTERPRISE_FEATURE_MESSAGE } from "../../../utils/constants";
import { isAdmin, isOrgEnterprise } from "../../../utils/io";
import theme from "../../../utils/theme";
import { NavContent } from "../Navbar";

function MainContentContainer(props) {
  const { title, docsUrl, children, isEnterpriseOnly, analyticsTitle } = props;
  const location = useLocation();
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname,
      page_title:
        analyticsTitle ||
        (typeof title === "string" ? title : location.pathname),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {isEnterpriseOnly && !isOrgEnterprise() && !isAdmin() && (
        <Box
          sx={{
            textAlign: "center",
            background: pink[200],
            padding: "7px 0",
            color: theme.colors.darkGrey,
            fontSize: theme.fontSize.medium,
            width: "100%",
            fontWeight: "bold",
          }}
        >
          {ENTERPRISE_FEATURE_MESSAGE}
        </Box>
      )}

      <Box sx={{ margin: { xs: "15px", md: "24px 40px" } }}>
        <Box sx={{ display: "flex", alignItems: "start", gap: 1 }}>
          {!isMobileOpen && (
            <Box
              sx={{
                display: { xs: "flex", md: "none" },
                top: 16,
                left: 16,
                zIndex: 1300,
              }}
            >
              <IconButton
                onClick={() => setIsMobileOpen(true)}
                sx={{
                  background: "#ececf2",
                  border: "1px solid #CDD6DC",
                  borderRadius: "8px",
                  "&:hover": { background: "#e0e0ea" },
                }}
              >
                <MenuIcon />
              </IconButton>
            </Box>
          )}
          <Box
            sx={{
              display: "flex",
              fontSize: 24,
              color: theme.colors.black,
              fontWeight: 700,
              alignItems: "center",
              flexWrap: "wrap",
              width: "100%",
            }}
          >
            {title}{" "}
            {docsUrl && (
              <Link href={docsUrl} target="_blank" rel="noopener">
                <InfoIcon
                  sx={{
                    ml: "5px",
                    pt: "5px",
                    fontSize: 20,
                    color: theme.colors.stelBlue,
                  }}
                />
              </Link>
            )}
          </Box>
        </Box>
        <Box>
          <Divider sx={{ mb: "16px", mt: "10px" }} />
          {children}
        </Box>
      </Box>

      <Drawer
        anchor="left"
        open={isMobileOpen}
        onClose={() => setIsMobileOpen(false)}
        sx={{
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: 204,
            background: "#ececf2",
            borderRight: "1px solid #CDD6DC",
          },
        }}
      >
        <NavContent />
      </Drawer>
    </>
  );
}
MainContentContainer.propTypes = {
  children: PropTypes.node.isRequired,
  docsUrl: PropTypes.string,
  isEnterpriseOnly: PropTypes.bool,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.node,
  ]).isRequired,
  analyticsTitle: PropTypes.string,
};
MainContentContainer.defaultProps = {
  isEnterpriseOnly: false,
  docsUrl: "",
  analyticsTitle: "",
};

export default MainContentContainer;
